module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Attendance Request",
      "visible": _vm.displayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      },
      "show": _vm.checkNepaliDateOrEnglish
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "p-fluid p-formgrid p-grid"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-6"
        }, [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": !_vm.editing ? 'Add' : 'Update'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addAttendanceRequest.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-info",
          attrs: {
            "label": "Add & New"
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })], 1)])]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "employeeName"
    }
  }, [_vm._v("Employee Name")]), _vm._v(" "), _c('AutoComplete', {
    ref: "itm",
    attrs: {
      "filterMatchMode": "contains",
      "suggestions": _vm.filteredEmployees,
      "field": "name"
    },
    on: {
      "complete": function($event) {
        return _vm.searchItem($event)
      }
    },
    model: {
      value: (_vm.epmloyee),
      callback: function($$v) {
        _vm.epmloyee = $$v
      },
      expression: "epmloyee"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "attendanceDate"
    }
  }, [_vm._v("Attendance Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.attendanceDate),
      callback: function($$v) {
        _vm.attendanceDate = $$v
      },
      expression: "attendanceDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "attendanceDate"
    },
    model: {
      value: (_vm.attendanceDate),
      callback: function($$v) {
        _vm.attendanceDate = $$v
      },
      expression: "attendanceDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "toDate"
    }
  }, [_vm._v("Date To")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "logTime"
    }
  }, [_vm._v("Log Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.logTimeStr),
      expression: "logTimeStr"
    }],
    staticClass: "p-inputtext p-component",
    attrs: {
      "type": "time",
      "id": "workhours"
    },
    domProps: {
      "value": (_vm.logTimeStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.logTimeStr = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "direction"
    }
  }, [_vm._v("Direction")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "optionLabel": "name",
      "placeholder": "Select Direction",
      "filter": true,
      "options": _vm.directions,
      "showClear": true,
      "id": "direction"
    },
    model: {
      value: (_vm.direction),
      callback: function($$v) {
        _vm.direction = $$v
      },
      expression: "direction"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "returnTime"
    }
  }, [_vm._v("Return Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnTimeStr),
      expression: "returnTimeStr"
    }],
    staticClass: "p-inputtext p-component",
    attrs: {
      "type": "time",
      "id": "workhours"
    },
    domProps: {
      "value": (_vm.returnTimeStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnTimeStr = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "outPlace"
    }
  }, [_vm._v("Out Place")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "outPlace"
    },
    model: {
      value: (_vm.outPlace),
      callback: function($$v) {
        _vm.outPlace = $$v
      },
      expression: "outPlace"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "remarks"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "cols": "30",
      "rows": "5",
      "id": "remarks"
    },
    model: {
      value: (_vm.remarks),
      callback: function($$v) {
        _vm.remarks = $$v
      },
      expression: "remarks"
    }
  })], 1)])]), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.attendanceRequestList,
      "filters": _vm.filters,
      "rowsPerPageOptions": [100, 500, 1000],
      "paginator": true,
      "rows": 100
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "S.N",
      "field": ""
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Name",
      "sortable": true,
      "field": "employeeName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['employeeName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'employeeName', $$v)
            },
            expression: "filters['employeeName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Direction",
      "sortable": true,
      "field": "direction",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['direction']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'direction', $$v)
            },
            expression: "filters['direction']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Date",
      "sortable": true,
      "field": "attendanceDate",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['attendanceDate']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'attendanceDate', $$v)
            },
            expression: "filters['attendanceDate']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Log Time",
      "sortable": true,
      "field": "logTimeStr",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['logTimeStr']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'logTimeStr', $$v)
            },
            expression: "filters['logTimeStr']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Date To",
      "sortable": true,
      "field": "dateTo",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['dateTo']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'dateTo', $$v)
            },
            expression: "filters['dateTo']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Return Time",
      "sortable": true,
      "field": "returnTimeStr",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['returnTimeStr']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'returnTimeStr', $$v)
            },
            expression: "filters['returnTimeStr']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Status",
      "sortable": true,
      "field": "status",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['status']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'status', $$v)
            },
            expression: "filters['status']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editAttendacneRequest(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDeleteDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ab8cf78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Attendance/attendanceRequestReport.vue
// module id = 2208
// module chunks = 0